import 'swiper/swiper-bundle.min.css';
import { FC, useCallback, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Img from "@/components/img";
import styles from "./styles/androiddownload.module.css";
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { PROD_SITE } from "@/const/prod.const";
import { appendHost } from "@/const/append";
import { generateQRCode } from "@/components/generateqr";
import u, { ELocalKey, ProjectInfo, teseConstant } from "@/util";
import Back from "@/components/back"
import { zIndex } from 'html2canvas/dist/types/css/property-descriptors/z-index';


SwiperCore.use([Autoplay, Pagination]);

const AndroidDownload: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [versionData, setVersionData] = useState<any>({});
  const [responseData, setResponseData] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalImages, setModalImages] = useState<string[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<any>();
  const [isInstallGuideOpen, setIsInstallGuideOpen] = useState(false);
  const [isDownloadingDialogOpen, setIsDownloadingDialogOpen] = useState(false); // New state for downloading dialog

  useEffect(() => {
    const loadBaiduAnalytics = () => {
      document.body.style.backgroundColor = 'black';
      document.body.style.color = 'white';

      const hmSrc = process.env.REACT_APP_STATIC_MM_APPDOWNLOAD_SRC1;

      if (hmSrc) {
        const script = document.createElement("script");
        script.src = hmSrc;
        script.async = true;
        const firstScript = document.getElementsByTagName("script")[0];
        firstScript?.parentNode?.insertBefore(script, firstScript);
      }
    };

    loadBaiduAnalytics();
  }, []);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 600);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const generateQR = async () => {
      try {
        let urlToGo = '';
        if (PROD_SITE === "1") {
          urlToGo = responseData?.android_app_download_1;
        } else if (PROD_SITE === "2") {
          urlToGo = responseData?.android_app_download_2;
        } else {
          urlToGo = responseData?.android_app_download_3;
        }

        const dataUrl = await generateQRCode(urlToGo);
        if (isMounted) {
          setQrCodeDataUrl(dataUrl);
        }
      } catch (error) {
        console.error("Failed to generate QR code:", error);
      }
    };

    generateQR();
    return () => {
      isMounted = false;
    };
  }, [responseData, PROD_SITE]);

  useEffect(() => {
    fetch('/version.json')
      .then(response => response.json())
      .then(data => setVersionData(data))
      .catch(error => console.log(error));
  }, []);

  useEffect(() => {
    const downloadAPI = process.env.REACT_APP_STATIC_DOWNLOAD;
    if (!downloadAPI) {
      console.error("REACT_APP_STATIC_DOWNLOAD is not defined.");
      return;
    }

    fetch(downloadAPI)
      .then(response => response.json())
      .then(data => {
        try {
          console.log('show downloadapi', downloadAPI);
          const decrypted = u.decrypt(data.data, data.suffix);
          const parsedData = JSON.parse(decrypted);
          setResponseData(parsedData);
          if (document.getElementById('office') && parsedData?.official_website) {
            document.getElementById('office')!.innerHTML = parsedData.official_website;
          }
        } catch (e) {
          console.error("Decryption error:", e);
        }
      })
      .catch(error => console.log(error));
  }, []);

  const openLink = (type: string) => {
    if (!responseData) return;

    let urlToGo = '';
    switch (type) {
      case 'android_download1':
        urlToGo = responseData.android_app_download_1;
        // Open the download link and show the downloading dialog first
        if (!urlToGo.includes('http')) {
          urlToGo = 'https://' + urlToGo;
        }
        window.location.href = urlToGo;
        setIsDownloadingDialogOpen(true); // Show downloading dialog first
            setIsInstallGuideOpen(true); // Open install guide after closing downloading dialog
        break;
      case 'android_download2':
        urlToGo = responseData.android_app_download_2;
        // Open the download link and show the downloading dialog first
        if (!urlToGo.includes('http')) {
          urlToGo = 'https://' + urlToGo;
        }
        window.location.href = urlToGo;
        setIsDownloadingDialogOpen(true); // Show downloading dialog first
            setIsInstallGuideOpen(true); // Open install guide after closing downloading dialog
        break;
      case 'android_download3':
        urlToGo = responseData.android_app_download_3;
        // Open the download link and show the downloading dialog first
        if (!urlToGo.includes('http')) {
          urlToGo = 'https://' + urlToGo;
        }
        window.location.href = urlToGo;
        setIsDownloadingDialogOpen(true); // Show downloading dialog first
        break;
      case 'report':
        urlToGo = responseData.feedback;
        break;
      case 'telegram':
        urlToGo = responseData.telegram_group;
        break;
      case 'business':
        urlToGo = responseData.merchant;
        break;
      case 'email':
        urlToGo = responseData.official_email;
        break;
      case 'qrcode':
        urlToGo = responseData.official_qr;
        break;
      case 'home':
        urlToGo = window.location.origin;
        break;
      default:
        urlToGo = responseData.official_website;
    }

    if (type !== 'android_download1' && type !== 'android_download2' && type !== 'android_download3' && !urlToGo.includes('http')) {
      urlToGo = 'https://' + urlToGo;
    }

    if (type !== 'android_download1' && type !== 'android_download2' && type !== 'android_download3') {
      window.location.href = urlToGo;
    }
  };

  // Auto-close logic
  useEffect(() => {
    if (isDownloadingDialogOpen) {
      const timer = setTimeout(() => {
        closeDownloadingDialog(); // auto close after 5s
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isDownloadingDialogOpen]);

  const downloadFile = (type: string) => {
    if (!versionData || !responseData) return;

    const params = new URLSearchParams(window.location.search);
    const paramInvite = params.get('invite');
    if (paramInvite) {
      const input = document.createElement('input');
      input.value = paramInvite;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
    }

    const targetUrl = versionData[type + '_url'] || responseData.android_app_download_1 || 'https://maomiav.com';
    window.location.href = targetUrl;
  };

  const copyText = (type: string) => {
    const targetUrl = versionData[type + '_url'] || responseData.official_website || 'https://maomiav.com';
    const input = document.createElement('input');
    input.value = targetUrl;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
  };

  const bannerList = [
    { img: "/assets/images/pc/img_slide1.png", alt: "Slide 1" },
    { img: "/assets/images/pc/img_slide2.png", alt: "Slide 2" },
    { img: "/assets/images/pc/img_slide3.png", alt: "Slide 3" }
  ];

  const handleDotClick = (index: number) => {
    const swiperElement = document.querySelector(".swiper") as HTMLElement & { swiper?: any };
    if (swiperElement?.swiper) {
      swiperElement.swiper.slideToLoop(index);
      setActiveIndex(index);
    }
  };

  const handleViewClick = (images: string[]) => {
    setModalImages(images);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImages([]);
  };

  const closeInstallGuide = () => {
    setIsInstallGuideOpen(false);
  };

  const closeDownloadingDialog = () => {
    setIsDownloadingDialogOpen(false);
    setIsInstallGuideOpen(true); // Open install guide after closing downloading dialog
  };

  return (
    <div className={`${styles.bgpage} body-dl`} style={{ backgroundImage: `url(${appendHost("/images/androioddownload/bg.png")}), linear-gradient(rgb(116 62 64 / 78%), rgb(116 62 64 / 77%))` }}>
      {/* <div className={`${styles.csicon}`} onClick={() => openLink('report')}>
        <Img width={100} height={100} alt='logo' src={appendHost("/images/androiddownload/csicon.png")} style={{ width: isMobile ? 50 : 50, height: isMobile ? 50 : 50 }} />
      </div> */}
      <div className={`${styles.mainlogo}`}>
        <div>
          <Img
            width={100}
            height={100}
            alt="logo"
            src={appendHost("/images/androiddownload/maomilogo_new1.png")}
            style={{ width: isMobile ? 57 : 70, height: isMobile ? 57 : 70 }}
          />
          <div className={`${styles.flexwangye}`}>
            <div className={`${styles.textwangye}`} onClick={() => openLink('home')}>
              网页在线看
            </div>
            <div
              className={`${styles.supportLink}`}
              onClick={() => openLink('report')}
            >
              <Img
                width={27}
                height={27}
                alt="support"
                src={appendHost("/images/androiddownload/support.png")}
                style={{ width: isMobile ? 14 : 19, height: isMobile ? 14 : 19 }}
              />
              联系客服
            </div>
          </div>
        </div>

        <div className={`${styles.title_wrapper}`}>
          <div className={`${styles.title}`}>猫咪视频</div>
          <div className={`${styles.sub_title}`}>您的专属成人片库</div>
          <div className={`${styles.leftLinks}`} />
        </div>
        <div className={`${styles.buttonGroup}`}>
          <div
            className={`${styles.downloadButton}`}
            onClick={() => openLink('android_download1')}
          >
            <Img
              width={32}
              height={32}
              alt="android"
              src={appendHost("/images/androiddownload/android_new.png")}
              style={{ width: isMobile ? 19 : 32, height: isMobile ? 25 : 32 }}
            />
            <div className={`${styles.buttonText}`}>
              <span className={`${styles.buttonMainText}`}>安卓下载 1</span>
              <span className={`${styles.buttonSubText}`}>建议XUC/夸克浏览器打开</span>
            </div>
          </div>
          <div
            className={`${styles.downloadButton}`}
            onClick={() => openLink('android_download2')}
          >
            <Img
              width={32}
              height={32}
              alt="android"
              src={appendHost("/images/androiddownload/android_new.png")}
              style={{ width: isMobile ? 19 : 32, height: isMobile ? 25 : 32 }}
            />
            <div className={`${styles.buttonText}`}>
              <span className={`${styles.buttonMainText}`}>安卓下载 2</span>
              <span className={`${styles.buttonSubText}`}>建议XUC/夸克浏览器打开</span>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.container}`}>
        <div className={`${styles.center}`}>
          <div className={`${styles.item}`}>
            <div className={`${styles.title}`}>每日更新</div>
            <div className={`${styles.value}`}>2000+</div>
          </div>
          <div className={`${styles.divider}`}></div>
          <div className={`${styles.item}`}>
            <div className={`${styles.title}`}>独家放送</div>
            <div className={`${styles.value}`}>1万+</div>
          </div>
          <div className={`${styles.divider}`}></div>
          <div className={`${styles.item}`}>
            <div className={`${styles.title}`}>无广纯享</div>
            <div className={`${styles.value}`}>24H</div>
          </div>
          <div className={`${styles.divider}`}></div>
          <div className={`${styles.item}`}>
            <div className={`${styles.title}`}>海量片库</div>
            <div className={`${styles.value}`}>100万+</div>
          </div>
        </div>
      </div>

      <div className={`${styles.notecontainer}`}>
        <div className={`${styles.notetitle}`}>
          温馨提示：
        </div>
        <div>
          - 如遇安装失败 请尝试用手机自带浏览器下载或参考下方安装教程
        </div>
        <div>
          - ios版本正在开发中，敬请期待
        </div>
        <div>
          - 如需帮助，请联系在线客服
        </div>
      </div>

      <div className={`${styles.slider}`}>
        <div className={`${styles.slider_wrapper}`}>
          <Img src={appendHost("/images/androiddownload/frame_6.png")} width={458} height={808} />
        </div>
        <div className={`${styles.slider_wrapper}`}>
          <Img src={appendHost("/images/androiddownload/frame_7.png")} width={458} height={808} />
        </div>
        <div className={`${styles.slider_wrapper}`}>
          <Img src={appendHost("/images/androiddownload/frame_8.png")} width={458} height={808} />
        </div>
        <div className={`${styles.slider_wrapper}`}>
          <Img src={appendHost("/images/androiddownload/frame_9.png")} width={458} height={808} />
        </div>
      </div>
      <div className={`${styles.install}`}>
        <h1 className={`${styles.title}`}>手机报读禁止安装解决方法</h1>
        {[
          {
            icon: "/images/androiddownload/gear1.png",
            text: "允许未知来源APP安装设置",
            images: ["/images/androiddownload/gear2_1.png"],
          },
          {
            icon: "/images/androiddownload/gear1.png",
            text: "禁止安装恶意软件设置",
            images: ["/images/androiddownload/gear2_2.png"],
          },
          {
            icon: "/images/androiddownload/huawei1.png",
            text: "华为手机安装APP和杀毒设置",
            images: ["/images/androiddownload/huawei2_1.png"],
          },
          {
            icon: "/images/androiddownload/huawei1.png",
            text: "华为纯净模式关闭操作",
            images: ["/images/androiddownload/huawei2_3.png"],
          },
          {
            icon: "/images/androiddownload/huawei1.png",
            text: "华为恶意应用",
            images: ["/images/androiddownload/huawei2_4.png"],
          },
          {
            icon: "/images/androiddownload/huawei1.png",
            text: "鸿蒙纯净版安装APP和杀毒设置",
            images: ["/images/androiddownload/huawei2_2.png"],
          },
          {
            icon: "/images/androiddownload/xiaomi.png",
            text: "小米手机安装APP和杀毒设置",
            images: ["/images/androiddownload/xiaomi_2.png"],
          },
          {
            icon: "/images/androiddownload/oppo.png",
            text: "OPPO手机安装APP和杀毒设置",
            images: ["/images/androiddownload/oppo_2.png"],
          },
          {
            icon: "/images/androiddownload/vivo.png",
            text: "VIVO手机安装APP和杀毒设置",
            images: ["/images/androiddownload/vivo_3.png"],
          },
          {
            icon: "/images/androiddownload/meizu.png",
            text: "MEIZU手机安装APP和杀毒设置",
            images: ["/images/androiddownload/meizu_2.png"],
          },
          {
            icon: "/images/androiddownload/tencent.png",
            text: "腾讯手机管家安全设置",
            images: ["/images/androiddownload/tencent_2.png"],
          },
        ].map(({ icon, text, images }, index) => (
          <div className={`${styles.card}`} key={index}>
            <div className={`${styles.icon}`}>
              <Img src={appendHost(icon)} alt={text} />
            </div>
            <div className={`${styles.text}`}>{text}</div>
            <button
              className={`${styles.button}`}
              onClick={() => handleViewClick(images)}
              aria-label={`View details for ${text}`}
            >
              查看
            </button>
          </div>
        ))}
      </div>

      {/* Modal for downloading dialog */}
      {isDownloadingDialogOpen && (
        <div
          style={{
            position: "fixed",
            top: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#4caf50", // green background
            color: "white",
            padding: "16px 24px",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 1111,
            textAlign: "center",
            minWidth: "250px",
          }}
        >
          {/* Close button */}
          <button
            onClick={closeDownloadingDialog}
            style={{
              position: "absolute",
              top: "8px",
              right: "12px",
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            ×
          </button>

          <h2 style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>正在下载中...</h2>
          <p style={{ margin: "8px 0 0 0", fontSize: "14px" }}>如果有遇到错误再查看教程。</p>
        </div>
      //   <div className={`${styles.modal}`} onClick={(e) => e.stopPropagation()} style={{zIndex :1001}}>
      //     <div className={`${styles.modalDownload}`} onClick={(e) => e.stopPropagation()} style={{ 
      //       display: 'flex', 
      //       flexDirection: 'column', 
      //       alignItems: 'center', 
      //       justifyContent: 'center',
      //       padding: '40px 20px',
      //       maxWidth: '400px',
      //       textAlign: 'center'
      //     }}>
      //       <h2 style={{ marginBottom: '20px', fontSize: '24px', fontWeight: 'bold', color: 'black' }}>正在下载中...</h2>
      //       <p style={{ marginBottom: '30px', fontSize: '16px', lineHeight: '1.5', color: 'black' }}>
      //       如果有遇到错误再查看教程。
      //       </p>
      //       <button 
      //         className={`${styles.button}`}
      //         onClick={closeDownloadingDialog}
      //         style={{
      //           padding: '12px 40px',
      //           fontSize: '16px',
      //           fontWeight: 'bold',
      //           cursor: 'pointer',
      //           borderRadius: '8px',
      //           border: 'none',
      //           backgroundColor: '#ff6b9d',
      //           color: 'white'
      //         }}
      //       >
      //         确认
      //       </button>
      //     </div>
      //   </div>
      )}

      {/* Modal for installation guide */}
      {isInstallGuideOpen && (
        <div className={`${styles.modal}`} onClick={closeInstallGuide} >
          
          <div className={`${styles.modalContent}`} onClick={(e) => e.stopPropagation()} style={{ backgroundImage: `url(${appendHost("/images/androioddownload/downloadbgcover.png")}), linear-gradient(rgb(116 62 64 / 78%), rgb(116 62 64 / 77%))` }}>
            <button className={`${styles.closeButton}`} onClick={closeInstallGuide}>
            <Back useWhiteIcon>手机报读禁止安装解决方法</Back>

            </button>
            <div className={`${styles.install}`}>
              {/* <h1 className={`${styles.title}`}>手机报读禁止安装解决方法</h1> */}
              {[
                {
                  icon: "/images/androiddownload/gear1.png",
                  text: "允许未知来源APP安装设置",
                  images: ["/images/androiddownload/gear2_1.png"],
                },
                {
                  icon: "/images/androiddownload/gear1.png",
                  text: "禁止安装恶意软件设置",
                  images: ["/images/androiddownload/gear2_2.png"],
                },
                {
                  icon: "/images/androiddownload/huawei1.png",
                  text: "华为手机安装APP和杀毒设置",
                  images: ["/images/androiddownload/huawei2_1.png"],
                },
                {
                  icon: "/images/androiddownload/huawei1.png",
                  text: "华为纯净模式关闭操作",
                  images: ["/images/androiddownload/huawei2_3.png"],
                },
                {
                  icon: "/images/androiddownload/huawei1.png",
                  text: "华为恶意应用",
                  images: ["/images/androiddownload/huawei2_4.png"],
                },
                {
                  icon: "/images/androiddownload/huawei1.png",
                  text: "鸿蒙纯净版安装APP和杀毒设置",
                  images: ["/images/androiddownload/huawei2_2.png"],
                },
                {
                  icon: "/images/androiddownload/xiaomi.png",
                  text: "小米手机安装APP和杀毒设置",
                  images: ["/images/androiddownload/xiaomi_2.png"],
                },
                {
                  icon: "/images/androiddownload/oppo.png",
                  text: "OPPO手机安装APP和杀毒设置",
                  images: ["/images/androiddownload/oppo_2.png"],
                },
                {
                  icon: "/images/androiddownload/vivo.png",
                  text: "VIVO手机安装APP和杀毒设置",
                  images: ["/images/androiddownload/vivo_3.png"],
                },
                {
                  icon: "/images/androiddownload/meizu.png",
                  text: "MEIZU手机安装APP和杀毒设置",
                  images: ["/images/androiddownload/meizu_2.png"],
                },
                {
                  icon: "/images/androiddownload/tencent.png",
                  text: "腾讯手机管家安全设置",
                  images: ["/images/androiddownload/tencent_2.png"],
                },
              ].map(({ icon, text, images }, index) => (
                <div className={`${styles.card}`} key={index}>
                  <div className={`${styles.icon}`}>
                    <Img src={appendHost(icon)} alt={text} />
                  </div>
                  <div className={`${styles.text}`}>{text}</div>
                  <button
                    className={`${styles.button}`}
                    onClick={() => handleViewClick(images)}
                    aria-label={`View details for ${text}`}
                  >
                    查看
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Modal for viewing images */}
      {isModalOpen && (
        <div className={`${styles.modal}`} onClick={closeModal}>
          <div className={`${styles.modalContent}`} onClick={(e) => e.stopPropagation()}>
            <div className={`${styles.imageContainer}`} onClick={closeModal}>
              {modalImages.map((image, index) => (
                <Img
                  key={index}
                  src={appendHost(image)}
                  alt={`Modal image ${index + 1}`}
                  style={{ maxWidth: '100%', borderRadius: '8px' }}
                  width={1000}
                  height="auto"
                />
              ))}
            </div>
          </div>
        </div>
      )}

      <div className={`${styles.download_container}`}>
        <img src={qrCodeDataUrl} width={130} height={130} alt="qrcode" style={{ background: 'white', padding: '5px', marginTop: '60px', borderRadius: '10px' }} />
        <p className={`${styles.qrcodetitle}`}>请打开手机浏览器扫一扫下载</p>
      </div>
      <div className={`${styles.download_btn}`} onClick={() => openLink('android_download1')}>
        <div className={`${styles.download_title}`}>
          立刻下载APP
        </div>
      </div>
    </div>
  );
};

export default AndroidDownload;